export default __webpack_public_path__ + "static/media/category-11.fed5561c.svg";